/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Word_PlaceholderInputs */

const en_pronunciation_report_word_placeholder = /** @type {(inputs: Pronunciation_Report_Word_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which word or phrase sounded wrong?`)
};

const es_pronunciation_report_word_placeholder = /** @type {(inputs: Pronunciation_Report_Word_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué palabra o frase sonó mal?`)
};

/**
* | output |
* | --- |
* | "Which word or phrase sounded wrong?" |
*
* @param {Pronunciation_Report_Word_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_word_placeholder = /** @type {((inputs?: Pronunciation_Report_Word_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Word_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_word_placeholder(inputs)
	return en_pronunciation_report_word_placeholder(inputs)
});